// eslint-disable-next-line @typescript-eslint/no-unused-vars

/** 查询权限的目标文件 */

/** 查询哪种权限 */
export var PermissionField = /*#__PURE__*/function (PermissionField) {
  PermissionField[PermissionField["CanCopy"] = 0] = "CanCopy";
  PermissionField[PermissionField["CanExport"] = 1] = "CanExport";
  PermissionField[PermissionField["CanPrint"] = 2] = "CanPrint";
  PermissionField[PermissionField["CanView"] = 3] = "CanView";
  PermissionField[PermissionField["CanEdit"] = 4] = "CanEdit";
  return PermissionField;
}({});
//# sourceMappingURL=permission.js.map